/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Order side as persisted by the canonical orders table and returned on the public order API.
 */
export enum OrderResponseSide {

    Buy = 'buy',

    Sell = 'sell'
}
